import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

// @ts-ignore
import ideaThread from '../assets/ideaThread.png';
// @ts-ignore
import nscia from '../assets/nscia.png';
// @ts-ignore
import prosperify from '../assets/prosperify.png';
// @ts-ignore
import stackies from '../assets/stackies.png';
// @ts-ignore
import thrive4Tomorrow from '../assets/thrive4Tomorrow.png';
import { messages as vendorManagementMessages } from '../i18n/vendor-management-messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const VendorManagement: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={348}
      height={142}
      fill="none"
    >
      <g clipPath="url(#vendorManagement-a)">
        <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        <g filter="url(#vendorManagement-b)">
          <g clipPath="url(#vendorManagement-c)">
            <rect
              width={80.94}
              height={95.74}
              x={2.45}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#vendorManagement-d)" d="M4.9 3.67h76.04v50.8H4.9V3.67Z" />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.9}
              fontWeight="bold"
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={6.12} y={63.11}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-1-cell-1']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={6.12} y={73.13}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-1-cell-2']
                )}
              </tspan>
            </text>
            <rect
              width={28.7}
              height={5.82}
              x={6.27}
              y={78.76}
              fill={tagBackgroundColors['purpleLight']}
              rx={0.77}
            />
            <rect
              width={28.7}
              height={5.82}
              x={6.27}
              y={78.76}
              stroke={tagBorderColors['purpleLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={8.44} y={82.75}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.field-3-select-option-1']
                )}
              </tspan>
            </text>
            <g clipPath="url(#vendorManagement-e)">
              <rect
                width={73.6}
                height={6.12}
                x={6.12}
                y={87.17}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#vendorManagement-f)">
                <path
                  fill={templateStyles['background']}
                  d="M7.04 88.1h4.28v4.27H7.04z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M8.6 90.14c-.05-.04-.12-.04-.15.02l-.69 1.38a.08.08 0 0 0 .08.12h.96a.08.08 0 0 0 .08-.04c.2-.43.08-1.09-.29-1.48Zm.5-1.26a1.8 1.8 0 0 0-.1 1.8l.46.94c.01.03.04.04.07.04h.97a.08.08 0 0 0 .07-.12l-1.33-2.66c-.03-.06-.1-.06-.14 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m13.25 92.17-.82-3.01h.4l.6 2.45h.02l.67-2.45h.38l.68 2.45h.02l.6-2.45h.4l-.82 3.01h-.36l-.7-2.38h-.02l-.7 2.38h-.35Zm3.5 0v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.13.09.28.09.45v1.46h-.36V90.8c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm2.6.8a.84.84 0 0 1-.15-.02v-.3l.07.01h.08c.1 0 .18-.02.25-.08a.55.55 0 0 0 .16-.27l.04-.13-.83-2.26h.39l.7 2.08-.15-.22h.17l-.15.22.7-2.08H21l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2c-.09.04-.2.06-.33.06Zm3.54 0a.84.84 0 0 1-.16-.02v-.3l.07.01h.08c.1 0 .19-.02.25-.08a.55.55 0 0 0 .16-.27l.04-.13-.83-2.26h.39l.7 2.08-.15-.22h.17l-.14.22.69-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2c-.09.04-.2.06-.33.06Zm2.97-.76a.95.95 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.62c0-.25.04-.45.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.36.4.08.18.12.38.12.63 0 .24-.04.45-.12.62a.93.93 0 0 1-.92.54Zm0-.32c.15 0 .27-.03.37-.1.1-.06.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.37-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.07.46c0 .18.02.33.07.45.06.13.13.23.23.3.1.06.22.1.36.1Zm2.36.32a.87.87 0 0 1-.42-.1.62.62 0 0 1-.27-.28 1.09 1.09 0 0 1-.08-.45v-1.46h.36v1.37c0 .2.04.35.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.51.51 0 0 0 .2-.13.53.53 0 0 0 .1-.2.84.84 0 0 0 .05-.27v-1.33h.36v2.25h-.36v-.33h-.04a.63.63 0 0 1-.14.2.64.64 0 0 1-.23.13.92.92 0 0 1-.3.04Zm1.75-.04v-2.25h.37v.33h.03a.53.53 0 0 1 .22-.27.82.82 0 0 1 .49-.1l.07.01v.36a1.05 1.05 0 0 0-.22-.02.66.66 0 0 0-.3.07.53.53 0 0 0-.22.19.54.54 0 0 0-.07.29v1.4h-.37Zm3.64.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.58h.38v.58h.49v.3h-.5v1.28c0 .13.03.23.08.28.05.06.14.09.25.09a1.33 1.33 0 0 0 .17 0v.3a2.66 2.66 0 0 1-.21.02Zm1.65.02c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.61c0-.24.04-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.37.12.59v.14H34.4v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.22.26.98.98 0 0 0-.09.42v.15c0 .16.03.3.09.4a.6.6 0 0 0 .58.36c.1 0 .2-.01.27-.04a.58.58 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.69.69 0 0 1-.1.22.83.83 0 0 1-.2.2.98.98 0 0 1-.28.13c-.1.04-.22.05-.35.05Zm2.14 0a.89.89 0 0 1-.38-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.35.6.6 0 0 1 .1-.35c.06-.1.15-.17.27-.23.13-.05.28-.08.45-.1l.83-.04v.29l-.79.05a.68.68 0 0 0-.37.1.31.31 0 0 0-.12.26c0 .12.04.21.13.27.09.07.2.1.33.1.12 0 .23-.03.33-.07.1-.05.17-.12.22-.2a.52.52 0 0 0 .09-.3v-.7c0-.14-.05-.24-.13-.32-.08-.07-.21-.1-.38-.1a.67.67 0 0 0-.33.07.35.35 0 0 0-.18.2h-.36a.6.6 0 0 1 .15-.32.78.78 0 0 1 .3-.2c.13-.05.27-.08.43-.08.19 0 .34.03.47.09.13.06.22.15.29.26.07.11.1.24.1.4v1.54h-.36v-.33h-.04a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm1.75-.04v-2.25h.36v.34h.03a.6.6 0 0 1 .23-.28c.1-.07.23-.1.38-.1.1 0 .2.02.28.05.08.03.15.08.2.14.06.06.11.13.15.2h.03a.73.73 0 0 1 .4-.35c.09-.02.19-.04.29-.04.15 0 .28.03.39.09.1.05.19.14.24.25.06.1.09.24.09.4v1.55h-.37V90.7c0-.11-.01-.2-.05-.28a.34.34 0 0 0-.15-.16.55.55 0 0 0-.27-.06c-.1 0-.2.03-.27.07a.5.5 0 0 0-.18.2.53.53 0 0 0-.07.26v1.44h-.36v-1.53a.45.45 0 0 0-.06-.23.38.38 0 0 0-.16-.15.53.53 0 0 0-.25-.06c-.1 0-.19.03-.27.08a.55.55 0 0 0-.18.2.62.62 0 0 0-.07.3v1.4h-.36Zm5.7.04c-.16 0-.31-.02-.44-.07a.78.78 0 0 1-.31-.22.6.6 0 0 1-.14-.32h.38c.03.1.09.17.18.23.09.05.2.08.35.08.1 0 .19-.01.26-.04a.46.46 0 0 0 .19-.13.27.27 0 0 0 .06-.18.25.25 0 0 0-.09-.2.7.7 0 0 0-.3-.13l-.35-.08a1.28 1.28 0 0 1-.35-.13.54.54 0 0 1-.2-.2.58.58 0 0 1-.06-.28c0-.13.03-.24.1-.34.08-.1.18-.18.3-.23.14-.06.28-.09.44-.09.15 0 .3.03.42.08a.62.62 0 0 1 .43.53h-.36a.37.37 0 0 0-.16-.22.6.6 0 0 0-.33-.09.61.61 0 0 0-.24.05.4.4 0 0 0-.17.11.27.27 0 0 0-.06.18c0 .05.01.1.04.14.03.04.07.07.12.1a1 1 0 0 0 .22.08l.35.08c.2.05.37.13.47.22.1.1.16.23.16.4 0 .13-.04.25-.12.35a.79.79 0 0 1-.33.24c-.13.06-.29.08-.46.08Zm1.5-.04v-3.15h.36v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.18 0 .32.03.44.1.11.06.2.16.26.28.06.13.1.28.1.45v1.46h-.37V90.8c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.33h-.37Zm3.42.04a.95.95 0 0 1-.91-.54 1.42 1.42 0 0 1-.13-.62c0-.25.04-.45.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.55.14.16.1.28.23.36.4.09.18.13.38.13.63 0 .24-.04.45-.13.62a.93.93 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.6.6 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.46c0 .18.03.33.08.45.05.13.13.23.23.3.1.06.22.1.36.1Zm2.36.32a.87.87 0 0 1-.43-.1.62.62 0 0 1-.26-.28 1.09 1.09 0 0 1-.09-.45v-1.46h.37v1.37c0 .2.04.35.12.45.07.1.2.15.38.15.1 0 .2-.01.27-.04a.51.51 0 0 0 .19-.13.53.53 0 0 0 .11-.2.84.84 0 0 0 .04-.27v-1.33h.37v2.25h-.37v-.33h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.22.13.92.92 0 0 1-.3.04Zm1.77-.04v-3.15h.36v3.15h-.36Zm1.9.04a.87.87 0 0 1-.84-.55 1.5 1.5 0 0 1-.11-.61c0-.24.04-.45.11-.62a.87.87 0 0 1 .83-.55.83.83 0 0 1 .54.19c.07.05.13.12.17.2h.03v-1.25h.36v3.15h-.36v-.35h-.03a.77.77 0 0 1-.18.21.77.77 0 0 1-.24.14.85.85 0 0 1-.29.04Zm.08-.32a.6.6 0 0 0 .35-.1c.1-.07.18-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.45a.65.65 0 0 0-.23-.3.6.6 0 0 0-.35-.1.6.6 0 0 0-.36.1.64.64 0 0 0-.22.3c-.05.12-.08.27-.08.45 0 .17.03.32.08.45s.13.22.22.3c.1.06.22.1.36.1Zm2.93.28v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.17.05-.05.11-.08.18-.08.07 0 .13.03.18.08.05.04.07.1.07.17s-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.87 2.7v-2.26h.36v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.41-.1.25 0 .45.07.58.22.14.14.2.35.2.61v1.46h-.36V90.8c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.05 0-.83-2.26h.38l.62 1.86h.03l.62-1.86h.38l-.83 2.25h-.37Zm2.52.03a.94.94 0 0 1-.91-.54 1.43 1.43 0 0 1-.12-.61c0-.24.04-.44.12-.62a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.34.4.08.17.11.37.11.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.22.26.98.98 0 0 0-.09.42v.15c0 .16.03.3.08.4a.6.6 0 0 0 .6.36c.1 0 .18-.01.26-.04a.58.58 0 0 0 .18-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.11.22.84.84 0 0 1-.2.2.98.98 0 0 1-.27.13c-.1.04-.23.05-.36.05Zm2.3 0c-.16 0-.31-.02-.44-.07a.78.78 0 0 1-.3-.22.6.6 0 0 1-.15-.32h.38c.03.1.09.17.18.23.09.05.2.08.35.08.1 0 .19-.01.26-.04a.46.46 0 0 0 .19-.13.27.27 0 0 0 .06-.18.25.25 0 0 0-.09-.2.7.7 0 0 0-.3-.13l-.35-.08a1.28 1.28 0 0 1-.34-.13.54.54 0 0 1-.2-.2.58.58 0 0 1-.07-.28c0-.13.04-.24.1-.34.08-.1.18-.18.3-.23.14-.06.28-.09.44-.09.16 0 .3.03.42.08a.62.62 0 0 1 .43.53h-.36a.37.37 0 0 0-.16-.22.6.6 0 0 0-.33-.09.61.61 0 0 0-.24.05.4.4 0 0 0-.17.11.27.27 0 0 0-.06.18c0 .05.02.1.04.14.03.04.07.07.12.1a1 1 0 0 0 .22.08l.35.08c.21.05.37.13.47.22.1.1.16.23.16.4 0 .13-.04.25-.12.35a.79.79 0 0 1-.33.24c-.13.06-.28.08-.46.08Zm2.25-.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.58h.38v.58h.5v.3h-.5v1.28c0 .13.02.23.08.28.05.06.13.09.25.09a1.33 1.33 0 0 0 .16 0v.3a2.68 2.68 0 0 1-.2.02Zm2.76 0c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.58h.38v.58h.5v.3h-.5v1.28c0 .13.03.23.08.28.05.06.13.09.25.09a1.33 1.33 0 0 0 .16 0v.3a2.71 2.71 0 0 1-.2.02Zm.77-.02v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.17.05-.05.11-.08.18-.08.07 0 .13.03.18.08.05.04.07.1.07.17s-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.16 2.72a.27.27 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.18.08.06.05.08.12.08.2 0 .07-.02.13-.08.19a.26.26 0 0 1-.19.08Zm1.08 0a.27.27 0 0 1-.2-.08.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.19a.27.27 0 0 1 .19-.08c.08 0 .14.03.2.08.05.05.07.12.07.2 0 .07-.02.13-.08.19a.26.26 0 0 1-.19.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={6.12}
              y={87.17}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#vendorManagement-g)">
          <g clipPath="url(#vendorManagement-h)">
            <rect
              width={80.94}
              height={95.74}
              x={85.84}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path
              fill="url(#vendorManagement-i)"
              d="M88.28 3.67h76.05v50.8H88.28V3.67Z"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.9}
              fontWeight="bold"
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={89.51} y={63.11}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-2-cell-1']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={89.51} y={73.13}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-2-cell-2']
                )}
              </tspan>
            </text>
            <rect
              width={40.7}
              height={5.82}
              x={89.66}
              y={78.76}
              fill={tagBackgroundColors['blueLight']}
              rx={0.77}
            />
            <rect
              width={40.7}
              height={5.82}
              x={89.66}
              y={78.76}
              stroke={tagBorderColors['blueLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={91.87} y={82.75}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.field-3-select-option-2']
                )}
              </tspan>
            </text>
            <g clipPath="url(#vendorManagement-j)">
              <rect
                width={73.6}
                height={6.12}
                x={89.51}
                y={87.17}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#vendorManagement-k)">
                <path
                  fill={templateStyles['background']}
                  d="M90.43 88.1h4.28v4.27h-4.28z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M91.98 90.14c-.04-.04-.1-.04-.14.02l-.7 1.38a.08.08 0 0 0 .01.08.08.08 0 0 0 .07.04h.97a.08.08 0 0 0 .07-.04c.21-.43.09-1.09-.28-1.48Zm.5-1.26c-.38.61-.35 1.3-.1 1.8l.47.94c.01.03.04.04.07.04h.97a.08.08 0 0 0 .07-.03.08.08 0 0 0 0-.09l-1.33-2.66c-.03-.06-.1-.06-.14 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m96.35 91.17-.02-.55h.1l1.32-1.46h.47l-1.25 1.35-.18.16-.44.5Zm-.34 1v-3.01h.38v3.01h-.38Zm1.83 0-1.13-1.5.26-.26 1.36 1.76h-.49Zm.96 0v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.17-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.17.05-.05.1-.08.17-.08s.13.03.18.08c.05.04.07.1.07.17s-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.8 2.73c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.61a.95.95 0 0 1 .91-.55c.18 0 .34.03.47.1a.85.85 0 0 1 .47.62v.01h-.36a.52.52 0 0 0-.19-.3.61.61 0 0 0-.39-.1.6.6 0 0 0-.58.39c-.05.12-.08.27-.08.44 0 .17.03.32.08.45.06.13.13.23.23.3.1.07.22.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.21-.28v-.02h.36v.03a.95.95 0 0 1-.16.36.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.49-.04v-3.15h.36v3.15h-.36Zm1.42 0-.88-1.1.27-.23 1.07 1.33h-.46Zm-1.1-.8-.02-.46h.1l.97-.99h.44l-1.07 1.03-.09.09-.33.32Zm4.11.84a.95.95 0 0 1-.91-.54 1.42 1.42 0 0 1-.13-.62c0-.25.05-.45.13-.63.09-.17.2-.3.36-.4.16-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.36.4.08.18.13.38.13.63 0 .24-.05.45-.13.62a.94.94 0 0 1-.92.54Zm0-.32c.15 0 .27-.03.37-.1.1-.06.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.61.61 0 0 0-.22-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.37.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.07.46c0 .18.02.33.07.45.06.13.13.23.23.3.1.06.22.1.36.1Zm1.76.28v-1.95h-.37v-.3h.37v-.25c0-.15.02-.28.07-.37.05-.1.13-.18.22-.22a.8.8 0 0 1 .36-.08 1.17 1.17 0 0 1 .25.02v.3l-.08-.01h-.1c-.12 0-.22.03-.27.09-.06.06-.09.16-.09.28v.24h.52v.3h-.52v1.95h-.36Zm1.55 0v-1.95h-.37v-.3h.37v-.25c0-.15.03-.28.07-.37.06-.1.13-.18.23-.22a.8.8 0 0 1 .36-.08 1.16 1.16 0 0 1 .24.02v.3a1.92 1.92 0 0 0-.17-.01c-.13 0-.22.03-.28.09-.06.06-.08.16-.08.28v.24h.5v.3h-.5v1.95H110Zm3.41.02c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.58h.38v.58h.5v.3h-.5v1.28c0 .13.02.23.07.28.05.06.14.09.25.09a1.3 1.3 0 0 0 .17 0v.3a2.7 2.7 0 0 1-.21.02Zm.78-.02v-3.15h.36v1.24h.03a.65.65 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.13.09.28.09.45v1.46h-.37V90.8c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.61c0-.24.05-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15.21 0 .39.05.53.14.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.17-.02-.32-.07-.43a.56.56 0 0 0-.22-.26.6.6 0 0 0-.33-.09.6.6 0 0 0-.32.1.6.6 0 0 0-.23.26.97.97 0 0 0-.08.42v.15c0 .16.02.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.01.26-.04a.57.57 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.82.82 0 0 1-.3.42.98.98 0 0 1-.27.13c-.11.04-.23.05-.36.05Zm2.73-.04v-2.25h.36v.34h.04a.64.64 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.14.14.2.35.2.61v1.46h-.36V90.8c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.33h-.36Zm3.42.04c-.21 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.61c0-.24.04-.44.12-.62a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.33.4.08.17.13.37.13.59v.14h-1.81v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.23.26.97.97 0 0 0-.08.42v.15c0 .16.03.3.08.4a.6.6 0 0 0 .6.36c.1 0 .18-.01.26-.04a.58.58 0 0 0 .18-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.68.68 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.22.05-.36.05Zm1.97-.04-.64-2.25h.37l.44 1.8h.03l.5-1.8h.35l.5 1.8h.04l.44-1.8h.37l-.64 2.25h-.36l-.5-1.74h-.04l-.5 1.74h-.36Zm4.27.8a.84.84 0 0 1-.16-.02v-.3l.08.01h.07c.1 0 .2-.02.26-.08a.55.55 0 0 0 .16-.27l.04-.13-.83-2.26h.38l.7 2.08-.15-.22h.18l-.15.22.7-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2.85.85 0 0 1-.34.06Zm2.98-.76c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.61c0-.24.04-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.81v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.22-.26.6.6 0 0 0-.32-.09.6.6 0 0 0-.33.1.6.6 0 0 0-.22.26.97.97 0 0 0-.09.42v.15c0 .16.03.3.09.4a.6.6 0 0 0 .58.36c.1 0 .2-.01.27-.04a.59.59 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.82.82 0 0 1-.3.42.98.98 0 0 1-.28.13c-.1.04-.22.05-.35.05Zm2.14 0a.89.89 0 0 1-.38-.08.63.63 0 0 1-.37-.59.6.6 0 0 1 .1-.34c.06-.1.15-.17.28-.23.12-.05.27-.08.44-.1l.83-.04v.29l-.79.05a.68.68 0 0 0-.37.1.31.31 0 0 0-.12.26c0 .12.04.21.13.27.09.07.2.1.33.1.12 0 .23-.03.33-.07.1-.05.17-.12.22-.2a.51.51 0 0 0 .09-.3v-.7c0-.14-.05-.24-.13-.32-.09-.07-.21-.1-.38-.1a.67.67 0 0 0-.33.07.35.35 0 0 0-.18.2h-.36a.61.61 0 0 1 .15-.32.78.78 0 0 1 .3-.2c.13-.05.27-.08.43-.08.19 0 .34.03.47.09.13.06.22.15.29.26.07.11.1.24.1.4v1.54h-.36v-.33h-.04a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm1.75-.04v-2.25h.36v.33h.03a.54.54 0 0 1 .22-.27.8.8 0 0 1 .49-.1l.08.01v.36a1.07 1.07 0 0 0-.23-.02.66.66 0 0 0-.3.07.53.53 0 0 0-.22.19.55.55 0 0 0-.07.29v1.4h-.36Zm3.27 0-.63-2.25h.36l.44 1.8h.04l.5-1.8h.35l.5 1.8h.03l.45-1.8h.36l-.63 2.25h-.37l-.5-1.74H141l-.5 1.74h-.36Zm2.89 0v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25c.07 0 .13.03.18.08.05.04.07.1.07.17s-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.67 2.71c-.23 0-.4-.05-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.35v-.3h.35v-.58h.38v.58h.5v.3h-.5v1.28c0 .13.02.23.07.28.05.06.14.09.25.09a1.3 1.3 0 0 0 .17 0v.3a2.95 2.95 0 0 1-.21.02Zm.78-.02v-3.15h.36v1.24h.03a.65.65 0 0 1 .25-.28c.1-.07.24-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.13.09.28.09.45v1.46h-.36V90.8c0-.2-.05-.35-.14-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.33h-.36Zm3.72 0v-3.15h.37v3.15h-.37Zm1.08 0v-2.25h.36v2.25h-.37Zm.18-2.69a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.17.05-.05.11-.08.18-.08.07 0 .13.03.18.08.04.04.07.1.07.17a.25.25 0 0 1-.25.25Zm1.5 2.7-.83-2.26h.38l.62 1.86h.03l.62-1.86h.39l-.84 2.25h-.37Zm2.52.03a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.61c0-.24.04-.44.12-.62a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.81v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.22.26.98.98 0 0 0-.09.42v.15c0 .16.03.3.08.4.06.12.14.2.24.27.1.06.21.09.35.09.1 0 .2-.01.27-.04a.59.59 0 0 0 .18-.1.38.38 0 0 0 .1-.14l.02-.02h.36v.02a.68.68 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.22.05-.36.05Zm2.76-.04v-3.15h.36v3.15h-.36Zm1.36.03a.26.26 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.26.26 0 0 1 .2-.08c.07 0 .14.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.08 0a.26.26 0 0 1-.19-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.26.26 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.1 0a.27.27 0 0 1-.28-.28c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.18.08.06.05.08.12.08.2 0 .07-.02.13-.08.19a.26.26 0 0 1-.19.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={89.51}
              y={87.17}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#vendorManagement-l)">
          <g clipPath="url(#vendorManagement-m)">
            <rect
              width={80.94}
              height={94.86}
              x={169.22}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path
              fill="url(#vendorManagement-n)"
              d="M171.67 3.67h76.05v50.8h-76.05V3.67Z"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.9}
              fontWeight="bold"
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={172.9} y={63.11}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-3-cell-1']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={172.9} y={72.69}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-3-cell-2']
                )}
              </tspan>
            </text>
            <rect
              width={15.7}
              height={5.82}
              x={173.05}
              y={77.88}
              fill={tagBackgroundColors['greyLight']}
              rx={0.77}
            />
            <rect
              width={15.7}
              height={5.82}
              x={173.05}
              y={77.88}
              stroke={tagBorderColors['greyLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={175.27} y={81.87}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.field-3-select-option-3']
                )}
              </tspan>
            </text>
            <g clipPath="url(#vendorManagement-o)">
              <rect
                width={73.6}
                height={6.12}
                x={172.9}
                y={86.3}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#vendorManagement-p)">
                <path
                  fill={templateStyles['background']}
                  d="M173.81 87.21h4.28v4.28h-4.28z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M175.37 89.26c-.04-.04-.11-.04-.14.02l-.7 1.38v.04l.01.04a.08.08 0 0 0 .07.04h.97a.08.08 0 0 0 .07-.04c.21-.43.08-1.09-.28-1.48Zm.5-1.26c-.38.61-.36 1.3-.1 1.8l.47.94c0 .03.04.04.07.04h.97a.08.08 0 0 0 .07-.03v-.04a.1.1 0 0 0 0-.05L176.02 88c-.03-.06-.1-.06-.14 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="M179.4 91.3v-3.02h1.87v.34h-1.5v.96h1.42v.34h-1.41v1.04h1.5v.34h-1.88Zm2.33 0 .77-1.13-.78-1.13h.43l.53.84h.04l.53-.84h.4l-.76 1.11.78 1.15h-.43l-.54-.86h-.03l-.53.86h-.41Zm3.23.01c-.24 0-.4-.04-.5-.14-.11-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.58h.37v.58h.5v.3h-.5v1.28c0 .13.03.23.08.28.05.06.13.09.25.09a1.37 1.37 0 0 0 .17 0v.3a2.7 2.7 0 0 1-.21.02Zm1.64.02a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.61c0-.24.04-.44.12-.62.09-.17.2-.31.35-.41.16-.1.34-.15.54-.15s.38.05.53.14c.14.1.26.23.33.4.08.17.12.37.12.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.23.26.98.98 0 0 0-.08.42v.15c0 .16.03.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.01.27-.04a.59.59 0 0 0 .18-.1.38.38 0 0 0 .1-.14l.01-.02h.37v.02a.68.68 0 0 1-.11.22.82.82 0 0 1-.2.2.97.97 0 0 1-.27.13c-.1.04-.23.05-.36.05Zm1.53-.03v-2.26h.36v.34h.04a.64.64 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.47h-.36v-1.38c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.34h-.36Zm3.33.03a.87.87 0 0 1-.83-.55 1.5 1.5 0 0 1-.11-.61c0-.24.04-.45.11-.62a.87.87 0 0 1 .83-.55.84.84 0 0 1 .54.19c.07.06.13.12.17.2h.03v-1.25h.36v3.16h-.36v-.36h-.03a.77.77 0 0 1-.7.4Zm.09-.32a.6.6 0 0 0 .35-.1c.1-.07.17-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.45a.65.65 0 0 0-.23-.3.6.6 0 0 0-.35-.1.6.6 0 0 0-.36.1.64.64 0 0 0-.22.3 1.2 1.2 0 0 0-.08.45c0 .17.03.32.08.45s.13.22.22.3c.1.06.22.1.36.1Zm3.72.3c-.23 0-.4-.04-.5-.14-.1-.1-.16-.25-.16-.46v-1.37h-.36v-.3h.36v-.58h.38v.58h.49v.3h-.5v1.28c0 .13.03.23.08.28.05.06.13.09.25.09a1.37 1.37 0 0 0 .17 0v.3a2.41 2.41 0 0 1-.21.02Zm.77-.01v-3.16h.37v1.24h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.18 0 .32.03.44.1.12.06.2.16.26.28a1 1 0 0 1 .1.45v1.47h-.37v-1.38c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.54.54 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.34h-.37Zm3.43.03c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.42 1.42 0 0 1-.13-.61c0-.24.04-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.17-.02-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.32.1.6.6 0 0 0-.23.26.98.98 0 0 0-.08.42v.15c0 .16.02.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.01.26-.04a.59.59 0 0 0 .19-.1.38.38 0 0 0 .1-.14v-.02h.37v.02a.68.68 0 0 1-.1.22.82.82 0 0 1-.2.2.97.97 0 0 1-.28.13c-.1.04-.22.05-.35.05Zm2.73-.03v-2.26h.36v.33h.04a.53.53 0 0 1 .22-.27.7.7 0 0 1 .38-.1h.1l.08.02v.35a1.02 1.02 0 0 0-.22-.02.66.66 0 0 0-.31.07.53.53 0 0 0-.21.19.54.54 0 0 0-.08.29v1.4h-.36Zm2.49.03c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.43 1.43 0 0 1-.13-.61c0-.24.05-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15.21 0 .39.05.53.14.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.17-.02-.32-.07-.43a.56.56 0 0 0-.55-.35.6.6 0 0 0-.32.1.6.6 0 0 0-.23.26.97.97 0 0 0-.08.42v.15c0 .16.02.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.01.26-.04a.59.59 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.22.84.84 0 0 1-.47.33c-.11.04-.23.05-.36.05Zm2.14 0a.89.89 0 0 1-.38-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.35.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.12-.05.27-.08.44-.1l.83-.04v.29l-.78.05a.68.68 0 0 0-.38.1.3.3 0 0 0-.12.26c0 .12.05.21.13.27.09.07.2.1.33.1.12 0 .23-.03.33-.07.1-.05.17-.12.23-.2a.51.51 0 0 0 .08-.3v-.7c0-.14-.04-.24-.13-.32-.08-.07-.2-.1-.38-.1a.67.67 0 0 0-.33.07.35.35 0 0 0-.17.2h-.37a.6.6 0 0 1 .15-.32.78.78 0 0 1 .3-.2c.13-.05.28-.08.44-.08.18 0 .34.03.46.09.13.06.23.15.3.26.06.11.1.25.1.4v1.55h-.37v-.34h-.03a.75.75 0 0 1-.69.37Zm2.67 0c-.2 0-.4-.04-.55-.14a.96.96 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.61a.95.95 0 0 1 .9-.55c.2 0 .35.03.48.1a.85.85 0 0 1 .47.62v.01h-.36a.52.52 0 0 0-.19-.29.61.61 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.05.12-.08.27-.08.44 0 .17.03.32.08.45s.13.23.23.3c.1.07.22.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.2-.28l.01-.01h.36v.02a.95.95 0 0 1-.16.36.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.5-.03v-3.16h.36v1.24h.03a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.17 0 .31.03.43.1.12.06.2.16.27.28.06.13.09.28.09.45v1.47h-.36v-1.38c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.34H211Zm4.63.03a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.45.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.35.4.09.18.13.38.13.63 0 .24-.04.45-.13.62a.94.94 0 0 1-.91.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.6.6 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.46c0 .18.03.33.08.45.05.13.13.23.23.3.1.06.22.1.36.1Zm1.76.29v-1.96H217v-.3h.38v-.25c0-.15.02-.28.07-.37.05-.1.12-.18.22-.22a.8.8 0 0 1 .36-.08 1.18 1.18 0 0 1 .24.02v.3l-.07-.01h-.1c-.13 0-.22.03-.28.09-.05.06-.08.16-.08.28v.24h.51v.3h-.51v1.96h-.36Zm2.8.79a.84.84 0 0 1-.17-.02v-.3l.08.01h.07c.1 0 .2-.02.26-.07a.55.55 0 0 0 .16-.28l.04-.13-.84-2.26h.4l.69 2.08-.14-.22h.17l-.15.22.7-2.08h.38l-.88 2.4c-.06.16-.13.3-.2.39a.56.56 0 0 1-.24.2.85.85 0 0 1-.34.06Zm2.97-.76a.95.95 0 0 1-.91-.54 1.42 1.42 0 0 1-.13-.62c0-.25.04-.45.13-.63.08-.17.2-.3.36-.4.15-.1.34-.14.55-.14.22 0 .4.05.56.14.15.1.27.23.35.4.09.18.13.38.13.63 0 .24-.04.45-.13.62a.93.93 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.61.61 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29c-.05.13-.08.28-.08.46s.03.33.08.45c.05.13.13.23.23.3.1.06.22.1.36.1Zm2.36.32a.88.88 0 0 1-.43-.1.63.63 0 0 1-.26-.28 1.1 1.1 0 0 1-.09-.45v-1.46h.37v1.37c0 .2.04.36.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.52.52 0 0 0 .19-.13.54.54 0 0 0 .11-.2.86.86 0 0 0 .04-.27v-1.33h.37v2.26h-.37v-.34h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.22.13.92.92 0 0 1-.3.04Zm1.75-.03v-2.26h.36v.33h.03a.53.53 0 0 1 .22-.27.7.7 0 0 1 .39-.1h.1l.08.02v.35a1.02 1.02 0 0 0-.22-.02.66.66 0 0 0-.31.07.53.53 0 0 0-.21.19.54.54 0 0 0-.08.29v1.4h-.36Zm3.63.01c-.23 0-.4-.04-.5-.14-.1-.1-.15-.25-.15-.46v-1.37h-.36v-.3h.36v-.58h.37v.58h.5v.3h-.5v1.28c0 .13.03.23.08.28.05.06.13.09.25.09a1.37 1.37 0 0 0 .17 0v.3a2.7 2.7 0 0 1-.22.02Zm1.65.02a.94.94 0 0 1-.91-.54 1.42 1.42 0 0 1-.12-.61c0-.24.04-.44.12-.62a.96.96 0 0 1 .89-.56c.2 0 .38.05.53.14.14.1.26.23.34.4.07.17.11.37.11.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.33.1.6.6 0 0 0-.23.26.98.98 0 0 0-.08.42v.15c0 .16.03.3.08.4.06.12.13.2.23.27a.77.77 0 0 0 .62.05.59.59 0 0 0 .2-.1.38.38 0 0 0 .1-.14v-.02h.37v.02a.68.68 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm2.15 0a.88.88 0 0 1-.39-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.35.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.12-.05.27-.08.45-.1l.82-.04v.29l-.78.05a.69.69 0 0 0-.38.1.31.31 0 0 0-.11.26c0 .12.04.21.13.27.08.07.2.1.32.1.13 0 .24-.03.33-.07.1-.05.18-.12.23-.2a.52.52 0 0 0 .08-.3v-.7c0-.14-.04-.24-.12-.32-.09-.07-.21-.1-.38-.1a.68.68 0 0 0-.34.07.35.35 0 0 0-.17.2h-.37a.6.6 0 0 1 .15-.32.79.79 0 0 1 .31-.2c.13-.05.27-.08.43-.08.18 0 .34.03.47.09.12.06.22.15.29.26.06.11.1.25.1.4v1.55h-.37v-.34h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm1.74-.03v-2.26h.37v.34h.03a.6.6 0 0 1 .23-.28c.1-.07.23-.1.38-.1.1 0 .2.02.27.05.08.03.15.08.21.14.06.06.1.13.14.2h.04a.72.72 0 0 1 .4-.35c.09-.02.18-.04.29-.04.15 0 .28.03.38.09.11.05.2.14.25.25.06.1.08.24.08.4v1.56h-.36v-1.48c0-.11-.02-.2-.05-.28a.33.33 0 0 0-.16-.16.55.55 0 0 0-.26-.06c-.1 0-.2.03-.28.07a.52.52 0 0 0-.25.45v1.46h-.36v-1.54a.45.45 0 0 0-.05-.23.38.38 0 0 0-.17-.15.53.53 0 0 0-.25-.06c-.1 0-.18.03-.26.08a.55.55 0 0 0-.19.2.63.63 0 0 0-.06.3v1.4h-.37Zm3.73-1.83.18-1.2h.42l-.33 1.2h-.27Zm1.3 1.85a.26.26 0 0 1-.2-.08.27.27 0 0 1-.08-.2c0-.07.03-.14.09-.19a.26.26 0 0 1 .19-.08c.07 0 .14.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.09 0a.27.27 0 0 1-.28-.28c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.08 0a.27.27 0 0 1-.27-.28c0-.07.03-.14.08-.19a.27.27 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.07.12.07.2 0 .07-.02.13-.07.19a.26.26 0 0 1-.2.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={172.9}
              y={86.3}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#vendorManagement-q)">
          <g clipPath="url(#vendorManagement-r)">
            <rect
              width={80.94}
              height={94.86}
              x={252.61}
              y={1.22}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path
              fill="url(#vendorManagement-s)"
              d="M255.06 3.67h76.04v50.8h-76.04V3.67Z"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.9}
              fontWeight="bold"
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={256.28} y={63.11}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-4-cell-1']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={256.28} y={72.69}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.entry-4-cell-2']
                )}
              </tspan>
            </text>
            <rect
              width={23.7}
              height={5.82}
              x={256.43}
              y={77.88}
              fill={tagBackgroundColors['yellowLight']}
              rx={0.77}
            />
            <rect
              width={23.7}
              height={5.82}
              x={256.43}
              y={77.88}
              stroke={tagBorderColors['yellowLight']}
              strokeWidth={0.3}
              rx={0.77}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontHeading']}
              fontSize={4.28}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={258.74} y={81.87}>
                {formatMessage(
                  vendorManagementMessages['vendor-management.field-3-select-option-4']
                )}
              </tspan>
            </text>
            <g clipPath="url(#vendorManagement-t)">
              <rect
                width={73.6}
                height={6.12}
                x={256.28}
                y={86.3}
                fill={templateStyles['background']}
                rx={0.92}
              />
              <g clipPath="url(#vendorManagement-u)">
                <path
                  fill={templateStyles['background']}
                  d="M257.2 87.21h4.28v4.28h-4.28z"
                />
                <path
                  fill={templateStyles['link']}
                  d="M258.76 89.26c-.05-.04-.11-.04-.14.02l-.7 1.38v.08a.08.08 0 0 0 .08.04h1l.03-.04c.2-.43.08-1.09-.28-1.48Zm.5-1.26c-.38.61-.36 1.3-.1 1.8l.46.94c.02.03.05.04.08.04h.96a.08.08 0 0 0 .07-.03l.02-.04a.1.1 0 0 0-.01-.05L259.4 88c-.03-.06-.1-.06-.15 0Z"
                />
              </g>
              <path
                fill={templateStyles['link']}
                d="m262.55 91.3 1.11-3.02h.29v.48h-.12l-.89 2.54h-.4Zm.5-.87.12-.32h1.36l.12.32h-1.6Zm1.7.87-.88-2.54v-.48h.16l1.12 3.02h-.4Zm.88 0v-2.26h.36v.34h.04a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.47h-.36v-1.38c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.34h-.36Zm2.5 0v-2.26h.37v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .45.07.59.22.14.14.2.35.2.61v1.47h-.36v-1.38c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.34h-.37Zm3.43.03c-.21 0-.4-.04-.55-.14a.95.95 0 0 1-.36-.4 1.42 1.42 0 0 1-.13-.62c0-.25.04-.45.13-.63a.94.94 0 0 1 .91-.54c.21 0 .4.05.56.14.15.1.27.23.35.4.09.18.13.38.13.63 0 .24-.04.45-.13.62a.94.94 0 0 1-.9.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.18-.16.23-.29.05-.12.08-.27.08-.45s-.03-.34-.08-.46a.6.6 0 0 0-.23-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.23.29 1.2 1.2 0 0 0-.08.46c0 .18.03.33.08.45.05.13.13.23.23.3.1.06.22.1.36.1Zm2.36.32a.88.88 0 0 1-.43-.1.63.63 0 0 1-.26-.28 1.1 1.1 0 0 1-.09-.45v-1.46h.37v1.37c0 .2.04.36.12.45.07.1.2.15.38.15.1 0 .2-.01.27-.04a.5.5 0 0 0 .19-.13.52.52 0 0 0 .11-.2.83.83 0 0 0 .04-.27v-1.33h.37v2.26h-.37v-.34h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.23.13.92.92 0 0 1-.29.04Zm1.75-.03v-2.26h.36v.34h.03a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.25 0 .45.07.58.22.14.14.21.35.21.61v1.47h-.36v-1.38c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.34h-.36Zm3.42.03c-.2 0-.4-.04-.55-.14a.96.96 0 0 1-.36-.4 1.4 1.4 0 0 1-.12-.63c0-.24.04-.44.12-.61a.96.96 0 0 1 .9-.55c.2 0 .35.03.48.1a.83.83 0 0 1 .47.62v.01h-.36a.51.51 0 0 0-.19-.29.61.61 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.06.12-.08.27-.08.44 0 .17.02.32.08.45.05.13.13.23.23.3.1.07.21.1.35.1.15 0 .28-.03.37-.1.1-.06.17-.16.2-.28l.01-.01h.36v.02a.97.97 0 0 1-.16.36.8.8 0 0 1-.31.24 1.1 1.1 0 0 1-.47.1Zm1.49-.03v-2.26h.36v2.26h-.37Zm.18-2.7a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.17.05-.05.11-.08.18-.08.07 0 .13.03.18.08.05.04.07.1.07.17s-.02.13-.07.18a.24.24 0 0 1-.18.08Zm.87 2.7v-2.26h.36v.34h.03a.64.64 0 0 1 .25-.28c.1-.07.24-.1.4-.1.26 0 .46.07.6.22.13.14.2.35.2.61v1.47h-.37v-1.38c0-.2-.04-.35-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.1-.07.2-.07.34v1.34h-.37Zm3.43.79c-.19 0-.34-.03-.48-.08a.78.78 0 0 1-.32-.21.64.64 0 0 1-.15-.33h.38c.02.09.08.16.18.21.1.06.22.09.38.09.2 0 .37-.05.48-.14.11-.1.17-.22.17-.39v-.45h-.03a.76.76 0 0 1-.42.34.92.92 0 0 1-.3.05.9.9 0 0 1-.5-.14.91.91 0 0 1-.32-.39 1.3 1.3 0 0 1-.12-.56c0-.21.04-.4.12-.56a.9.9 0 0 1 .84-.53c.1 0 .2.02.29.05.09.03.17.08.24.14a.8.8 0 0 1 .17.22h.02v-.37h.37v2.22c0 .17-.04.32-.12.44a.78.78 0 0 1-.35.29c-.15.07-.33.1-.53.1Zm-.02-1.23c.14 0 .26-.04.36-.1.1-.07.17-.16.23-.27a.9.9 0 0 0 .08-.4.92.92 0 0 0-.08-.4.62.62 0 0 0-.23-.27.63.63 0 0 0-.36-.1.62.62 0 0 0-.36.1.64.64 0 0 0-.22.27 1 1 0 0 0-.07.4c0 .15.02.29.07.4.05.11.13.2.22.27.1.06.22.1.36.1Zm4.16.5c-.27 0-.5-.06-.7-.19-.2-.12-.36-.3-.47-.54-.1-.24-.16-.52-.16-.84 0-.33.06-.61.16-.85.11-.23.26-.41.46-.54.2-.13.44-.2.71-.2.21 0 .4.05.58.13.17.08.32.2.43.35.11.14.18.31.21.5h-.38a.83.83 0 0 0-.84-.63.85.85 0 0 0-.83.58c-.07.18-.11.4-.11.65 0 .26.04.48.11.66.08.19.19.33.33.43.14.1.31.15.5.15.14 0 .27-.02.39-.07a.71.71 0 0 0 .45-.5h.38a1.04 1.04 0 0 1-.64.8c-.17.08-.36.12-.58.12Zm2.74-.03a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.45.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.56-.14.21 0 .4.05.55.14.15.1.27.23.36.4.08.18.13.38.13.63 0 .24-.05.45-.13.62a.94.94 0 0 1-.92.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.37-.1.63.63 0 0 0-.36.1.62.62 0 0 0-.22.29 1.2 1.2 0 0 0-.08.46c0 .18.02.33.08.45.05.13.13.23.22.3.1.06.22.1.37.1Zm1.6.29v-2.26h.36v.34h.04a.65.65 0 0 1 .24-.28c.11-.07.25-.1.41-.1.26 0 .45.07.59.22.13.14.2.35.2.61v1.47h-.36v-1.38c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.05.1-.08.2-.08.34v1.34h-.36Zm2.65 0v-1.96h-.37v-.3h.37v-.25c0-.15.03-.28.08-.37.05-.1.12-.18.22-.22a.8.8 0 0 1 .36-.08 1.18 1.18 0 0 1 .24.02v.3l-.08-.01h-.09c-.13 0-.22.03-.28.09-.06.06-.08.16-.08.28v.24h.5v.3h-.5v1.96h-.37Zm1.43 0v-3.16h.36v3.16h-.37Zm1.81.03a.88.88 0 0 1-.43-.1.63.63 0 0 1-.26-.28 1.1 1.1 0 0 1-.08-.45v-1.46h.36v1.37c0 .2.04.36.12.45.08.1.2.15.39.15.1 0 .18-.01.26-.04a.52.52 0 0 0 .2-.13.54.54 0 0 0 .1-.2.86.86 0 0 0 .05-.27v-1.33h.36v2.26h-.36v-.34h-.04a.63.63 0 0 1-.15.2.64.64 0 0 1-.22.13.92.92 0 0 1-.3.04Zm2.67 0a.94.94 0 0 1-.91-.54 1.43 1.43 0 0 1-.12-.61c0-.24.04-.44.12-.62.08-.17.2-.31.35-.41.15-.1.33-.15.54-.15.2 0 .38.05.52.14.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.8v-.29h1.62l-.18.27v-.15c0-.17-.03-.32-.08-.43a.56.56 0 0 0-.55-.35.6.6 0 0 0-.32.1.6.6 0 0 0-.23.26.97.97 0 0 0-.08.42v.15c0 .16.03.3.08.4a.6.6 0 0 0 .59.36c.1 0 .19-.01.26-.04a.59.59 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.11.22.84.84 0 0 1-.47.33c-.1.04-.23.05-.36.05Zm1.53-.03v-2.26h.36v.34h.03a.65.65 0 0 1 .25-.28c.1-.07.25-.1.41-.1.25 0 .45.07.58.22.14.14.21.35.21.61v1.47h-.36v-1.38c0-.2-.05-.35-.13-.45-.09-.1-.22-.15-.4-.15a.6.6 0 0 0-.31.08.53.53 0 0 0-.2.22c-.06.1-.08.2-.08.34v1.34h-.36Zm3.42.03c-.2 0-.4-.04-.55-.14a.96.96 0 0 1-.36-.4 1.41 1.41 0 0 1-.12-.63c0-.24.04-.44.12-.61a.95.95 0 0 1 .9-.55c.2 0 .35.03.48.1a.83.83 0 0 1 .47.62v.01h-.36a.52.52 0 0 0-.19-.29.61.61 0 0 0-.4-.12.6.6 0 0 0-.57.4c-.06.12-.08.27-.08.44 0 .17.03.32.08.45s.13.23.23.3c.1.07.22.1.35.1.15 0 .27-.03.37-.1.1-.06.17-.16.2-.28l.01-.01h.36v.02a.97.97 0 0 1-.17.36.8.8 0 0 1-.3.24 1.1 1.1 0 0 1-.47.1Zm2.4 0c-.22 0-.4-.04-.56-.14a.94.94 0 0 1-.35-.4 1.42 1.42 0 0 1-.13-.61c0-.24.04-.44.13-.62.08-.17.2-.31.35-.41.15-.1.33-.15.53-.15s.38.05.53.14c.15.1.26.23.34.4.08.17.12.37.12.59v.14h-1.8v-.29h1.61l-.18.27v-.15c0-.17-.02-.32-.08-.43a.56.56 0 0 0-.54-.35.6.6 0 0 0-.32.1.6.6 0 0 0-.23.26.98.98 0 0 0-.08.42v.15c0 .16.02.3.08.4a.6.6 0 0 0 .58.36c.1 0 .2-.01.27-.04a.59.59 0 0 0 .19-.1.38.38 0 0 0 .1-.14v-.02h.37v.02a.68.68 0 0 1-.1.22.82.82 0 0 1-.2.2.97.97 0 0 1-.28.13c-.1.04-.22.05-.35.05Zm3.99.04a1.26 1.26 0 0 1-1.17-.74c-.1-.24-.16-.52-.16-.84 0-.33.05-.61.16-.85.1-.23.26-.41.46-.54.2-.13.44-.2.7-.2.22 0 .41.05.58.13.18.08.32.2.44.35.1.14.18.31.2.5h-.37a.83.83 0 0 0-.84-.63c-.2 0-.36.05-.5.15a.96.96 0 0 0-.33.43c-.08.18-.12.4-.12.65 0 .26.04.48.12.66.08.19.19.33.33.43.14.1.3.15.5.15.14 0 .27-.02.38-.07a.8.8 0 0 0 .3-.2.7.7 0 0 0 .15-.3h.39c-.03.19-.1.35-.22.49-.11.13-.25.24-.42.31-.17.08-.37.12-.58.12Zm1.83-.07v-3.16h.36v3.16h-.36Zm1.99.03a.95.95 0 0 1-.91-.54 1.43 1.43 0 0 1-.13-.62c0-.25.04-.45.12-.63.09-.17.2-.3.36-.4.16-.1.34-.14.56-.14.21 0 .4.05.55.14.15.1.27.23.36.4.08.18.13.38.13.63 0 .24-.05.45-.13.62a.94.94 0 0 1-.91.54Zm0-.32c.14 0 .26-.03.36-.1.1-.06.17-.16.22-.29.06-.12.08-.27.08-.45s-.02-.34-.08-.46a.6.6 0 0 0-.22-.29.63.63 0 0 0-.36-.1.63.63 0 0 0-.37.1.62.62 0 0 0-.22.29 1.2 1.2 0 0 0-.08.46c0 .18.02.33.08.45.05.13.13.23.22.3.1.06.22.1.37.1Zm2.36.32a.88.88 0 0 1-.43-.1.62.62 0 0 1-.26-.28 1.1 1.1 0 0 1-.1-.45v-1.46h.37v1.37c0 .2.04.36.12.45.08.1.2.15.39.15.1 0 .19-.01.26-.04a.51.51 0 0 0 .2-.13.52.52 0 0 0 .1-.2.83.83 0 0 0 .05-.27v-1.33h.36v2.26h-.36v-.34h-.03a.63.63 0 0 1-.15.2.64.64 0 0 1-.23.13.92.92 0 0 1-.3.04Zm2.57 0a.87.87 0 0 1-.82-.55 1.5 1.5 0 0 1-.12-.61c0-.24.04-.45.12-.62a.95.95 0 0 1 .32-.4c.15-.1.31-.15.5-.15a.83.83 0 0 1 .54.19c.07.06.13.12.17.2h.03v-1.25h.37v3.16h-.37v-.36h-.03a.78.78 0 0 1-.18.21.78.78 0 0 1-.53.18Zm.09-.32a.6.6 0 0 0 .35-.1c.1-.07.18-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.45a.65.65 0 0 0-.23-.3.6.6 0 0 0-.35-.1.6.6 0 0 0-.35.1.64.64 0 0 0-.23.3c-.05.12-.08.27-.08.45 0 .17.03.32.08.45s.13.22.23.3c.1.06.21.1.35.1Zm2.01.3a.27.27 0 0 1-.2-.07.27.27 0 0 1-.07-.2c0-.07.03-.14.08-.19a.27.27 0 0 1 .19-.08c.08 0 .14.03.2.08.05.05.07.12.07.2 0 .07-.02.13-.08.19a.26.26 0 0 1-.19.08Zm1.09 0a.26.26 0 0 1-.2-.07.27.27 0 0 1-.07-.2c0-.07.02-.14.08-.19a.26.26 0 0 1 .19-.08c.07 0 .14.03.2.08.04.05.07.12.07.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Zm1.09 0a.26.26 0 0 1-.2-.07.27.27 0 0 1-.08-.2c0-.07.03-.14.08-.19a.26.26 0 0 1 .2-.08c.07 0 .13.03.19.08.05.05.08.12.08.2 0 .07-.03.13-.08.19a.26.26 0 0 1-.2.08Z"
              />
            </g>
            <rect
              width={73.6}
              height={6.12}
              x={256.28}
              y={86.3}
              stroke={templateStyles['border']}
              strokeWidth={0.31}
              rx={0.92}
            />
          </g>
        </g>
        <g filter="url(#vendorManagement-v)">
          <g clipPath="url(#vendorManagement-w)">
            <rect
              width={80.94}
              height={104.31}
              x={2.45}
              y={99.42}
              fill={templateStyles['background']}
              rx={1.84}
            />
            <path fill="url(#vendorManagement-x)" d="M4.9 101.86h76.04v50.8H4.9v-50.8Z" />
          </g>
        </g>
        <g filter="url(#vendorManagement-y)">
          <g clipPath="url(#vendorManagement-z)">
            <rect
              width={80.94}
              height={104.31}
              x={85.84}
              y={99.42}
              fill={templateStyles['background']}
              rx={1.84}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="vendorManagement-a">
          <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        </clipPath>
        <clipPath id="vendorManagement-c">
          <rect
            width={80.94}
            height={95.74}
            x={2.45}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="vendorManagement-e">
          <rect
            width={73.6}
            height={6.12}
            x={6.12}
            y={87.17}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="vendorManagement-f">
          <path fill={templateStyles['background']} d="M7.04 88.1h4.28v4.27H7.04z" />
        </clipPath>
        <clipPath id="vendorManagement-h">
          <rect
            width={80.94}
            height={95.74}
            x={85.84}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="vendorManagement-j">
          <rect
            width={73.6}
            height={6.12}
            x={89.51}
            y={87.17}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="vendorManagement-k">
          <path fill={templateStyles['background']} d="M90.43 88.1h4.28v4.27h-4.28z" />
        </clipPath>
        <clipPath id="vendorManagement-m">
          <rect
            width={80.94}
            height={94.86}
            x={169.22}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="vendorManagement-o">
          <rect
            width={73.6}
            height={6.12}
            x={172.9}
            y={86.3}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="vendorManagement-p">
          <path fill={templateStyles['background']} d="M173.81 87.21h4.28v4.28h-4.28z" />
        </clipPath>
        <clipPath id="vendorManagement-r">
          <rect
            width={80.94}
            height={94.86}
            x={252.61}
            y={1.22}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="vendorManagement-t">
          <rect
            width={73.6}
            height={6.12}
            x={256.28}
            y={86.3}
            fill={templateStyles['background']}
            rx={0.92}
          />
        </clipPath>
        <clipPath id="vendorManagement-u">
          <path fill={templateStyles['background']} d="M257.2 87.21h4.28v4.28h-4.28z" />
        </clipPath>
        <clipPath id="vendorManagement-w">
          <rect
            width={80.94}
            height={104.31}
            x={2.45}
            y={99.42}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <clipPath id="vendorManagement-z">
          <rect
            width={80.94}
            height={104.31}
            x={85.84}
            y={99.42}
            fill={templateStyles['background']}
            rx={1.84}
          />
        </clipPath>
        <filter
          id="vendorManagement-b"
          width={81.55}
          height={96.66}
          x={2.14}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <filter
          id="vendorManagement-g"
          width={81.55}
          height={96.66}
          x={85.53}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <filter
          id="vendorManagement-l"
          width={81.55}
          height={95.78}
          x={168.92}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <filter
          id="vendorManagement-q"
          width={81.55}
          height={95.78}
          x={252.31}
          y={0.92}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <filter
          id="vendorManagement-v"
          width={81.55}
          height={105.23}
          x={2.14}
          y={99.11}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <filter
          id="vendorManagement-y"
          width={81.55}
          height={105.23}
          x={85.53}
          y={99.11}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.31} />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_14426" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.15} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_14426"
            result="effect2_dropShadow_1228_14426"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_14426"
            result="shape"
          />
        </filter>
        <pattern
          id="vendorManagement-d"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#vendorManagement-A" transform="scale(.0003 .0004)" />
        </pattern>
        <pattern
          id="vendorManagement-i"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#vendorManagement-B" transform="scale(.0003 .0004)" />
        </pattern>
        <pattern
          id="vendorManagement-n"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#vendorManagement-C" transform="scale(.0003 .0004)" />
        </pattern>
        <pattern
          id="vendorManagement-s"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use
            xlinkHref="#vendorManagement-D"
            transform="matrix(.0003 0 0 .0005 -.2 0)"
          />
        </pattern>
        <pattern
          id="vendorManagement-x"
          width={1}
          height={1}
          patternContentUnits="objectBoundingBox"
        >
          <use xlinkHref="#vendorManagement-E" transform="scale(.0003 .0004)" />
        </pattern>
        <image
          xlinkHref={ideaThread}
          id="vendorManagement-A"
          width={4096}
          height={2731}
        />
        <image
          xlinkHref={prosperify}
          id="vendorManagement-B"
          width={4096}
          height={2731}
        />
        <image xlinkHref={stackies} id="vendorManagement-C" width={3993} height={2652} />
        <image
          xlinkHref={thrive4Tomorrow}
          id="vendorManagement-D"
          width={4096 * 1.1}
          height={1975 * 1.1}
        />
        <image
          xlinkHref={nscia}
          id="vendorManagement-E"
          width={3840 * 0.88}
          height={2160}
        />
      </defs>
    </svg>
  );
};
export default VendorManagement;
